import Api from '@/services/Api'
// const API_PARTIDO = "partido/";
// const API_URL = "";

export default {
    all(credentials) {
        return Api().get('filtro', credentials)
    },

    add(credentials) {
        return Api().post('filtro', credentials)
    },
    
    
    del(credentials) {
        return Api().delete('filtro/' + credentials)
    },

    getProyeccion (data) {
        return Api().get('filtro/proyeccion', data )
    }

    // add(credentials) {
    //     return Api().post(API_URL + 'add', credentials)
    // },

    // edit(credentials) {
    //     return Api().put(API_URL + API_PARTIDO + 'edit', credentials)
    // },


}